/**
 * @desc 门店二级分类
 */

import { RequestConfig, request } from 'umi';
export interface Params {
  /** store_type */
  store_type: number;
}

function req(params: Params, config: Parameters<typeof request>[1] = {}) {
  return request<defs.store.GeneralHttpResponse<Array<defs.store.PairEntity>>>(
    `/storeapi/inner/address/sub/store/types`,
    {
      params,
      method: 'get',
      ...(config || {}),
    },
  );
}
req.req = {} as Parameters<typeof req>[0];
req.res = {} as defs.store.GeneralHttpResponse<Array<defs.store.PairEntity>>;
export default req;
